import { render, staticRenderFns } from "./ProgramStatusItem.vue?vue&type=template&id=10ef3af7&scoped=true&"
import script from "./ProgramStatusItem.vue?vue&type=script&lang=ts&"
export * from "./ProgramStatusItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramStatusItem.vue?vue&type=style&index=0&id=10ef3af7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef3af7",
  null
  
)

export default component.exports